import ImgAboutMe from '../assets/img/me/me_photo.jpg'

export const DataImgMe = [{
    id: 1,
    img:ImgAboutMe
}]